import { Chip, Grid, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React from "react";
import CustomNoRowsOverlay from "../../newComponent/TableCustomeComp/CustomNoRowsOverlay";
import { fDate, useDateUtils } from "../../../utils/formatTime";

export default function DemoDetails({
  selectedFilter,
  SelectedData,

  monthName,
  selectedYear,
  fromDate,
  toDate,
  
}) {
  const { currentMonthName, lastMonthName, weekRange, currentYear } =
    useDateUtils();
  let currentDate = new Date().toISOString().split("T")[0];
  const userRole=localStorage.getItem('userRole')

  const columns = [
    {
      field: "enquiry_name",
      headerName: "Enquiry Name",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        `${params?.row?.enquiry_id?.first_name || ""} ${
          params?.row?.enquiry_id?.last_name || ""
        }`,
      renderCell: (params) => (
        <div
          style={{
            color: "#0096FF",

            cursor: "pointer",
            "&:hover": {
              textDecoration: "none",
            },
          }}
          onClick={() =>
            window.open(
              `/enquirydetails/${params?.row.enquiry_id.id}`,
              "_blank"
            )
          }
        >
          {" "}
          {`${
            params?.row?.enquiry_id?.first_name
              ? params?.row?.enquiry_id?.first_name
              : ""
          } ${
            params?.row?.enquiry_id?.last_name
              ? params?.row?.enquiry_id?.last_name
              : ""
          }`}{" "}
        </div>
      ),
    },
    {
      field: "mobile",
      headerName: "Mobile",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row?.enquiry_id?.mobile || "",
      renderCell: (params) => <div>{params.row?.enquiry_id?.mobile_country_code}

      {userRole === "advisor" || userRole === "trainer"
        ? params.row?.enquiry_id?.mobile?.replace(/.(?=.{4,}$)/g, "*")
        : params.row?.enquiry_id?.mobile}</div>,
    },

    {
      field: "class_name",
      headerName: "Class Name",
      flex: 1,
      minWidth: 250,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row?.class_id?.name || "",
      renderCell: (params) => <div>{params?.row.class_id?.name} </div>,
    },
    {
      field: "trainer_id",
      headerName: "Trainer Name",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row?.trainer_id?.first_name || "",
      renderCell: (params) => (
        <div>
          {params?.row.trainer_id?.first_name}{" "}
          {params?.row.trainer_id?.last_name}
        </div>
      ),
    },
    {
      field: "available_demo_date",
      headerName: "Demo Date",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row?.available_demo_date || "",
      renderCell: (params) => (
        <div>{fDate(params?.row?.available_demo_date)}</div>
      ),
    },

    {
      field: "slot",
      headerName: "Slot",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row?.slot || "",
      renderCell: (params) => <div>{params?.row?.slot}</div>,
    },
    {
      field: "delivery_mode",
      headerName: "Delivary Mode",
      flex: 1,
      minWidth: 100,
      headerClassName: "header-cell",
      
    },
    {
      field: "demo_branch",
      headerName: "Demo Branch",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row?.branch_id?.branch_name || "",
      renderCell: (params) => <div>{params?.row?.branch_id?.branch_name}</div>,
    },
    {
      field: "demo_created_by",
      headerName: "Demo Created By",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row?.created_by?.first_name || "",
      renderCell: (params) => (
        <div>
          {params?.row.created_by?.first_name}{" "}
          {params?.row.created_by?.last_name}
        </div>
      ),
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      
    },
    // {
    //   field: "branch",
    //   headerName: "Branch",
    //   flex: 1,
    //   minWidth: 150,
    //   headerClassName: "header-cell",
    //   valueGetter: (params) => params?.row?.enquiry_id?.mobile || "",
    //   renderCell: (params) => <div>{params?.row.enquiry_id?.mobile}</div>,
    // },
  ];
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          {selectedFilter === "default" && (
            <Typography variant="h4" textAlign="center">
              {monthName} {selectedYear}
            </Typography>
          )}
          {selectedFilter === "today" && (
            <Typography variant="h4" textAlign="center">
              Today ({currentDate})
            </Typography>
          )}
          {selectedFilter === "currentweek" && (
            <Typography variant="h4" textAlign="center">
              This Week ({weekRange})
            </Typography>
          )}

          {selectedFilter === "currentmonth" && (
            <Typography variant="h4" textAlign="center">
              {currentMonthName} {currentYear}
            </Typography>
          )}

          {selectedFilter === "custom" && (
            <Typography variant="h4" textAlign="center">
              {fromDate} - {toDate}
            </Typography>
          )}
        </Grid>
        <Grid item xs={12}>
          <DataGrid
            rows={SelectedData}
            columns={columns}
            slots={{
              noRowsOverlay: CustomNoRowsOverlay,
            }}
            autoHeight
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 25,
                },
              },
            }}
            pageSizeOptions={[25, 50, 100]}
          />
        </Grid>
      </Grid>
    </>
  );
}
